/* eslint-disable no-param-reassign,no-unused-vars */
import Vue from 'vue';
import md5 from 'md5';
import numeral from 'numeral';
import adminApi from '../api/admin';
import userApi from '../api/user';
import systemApi from '../api/system';
import tenantApi from '../api/tenant';
import tenantService from '../service/tenant.service';
import i18n from '../i18n';
import UiEventBus from '../UiEventBus';
import FileNameValidator from '@/plugins/filenamevalidator.plugin';
import dayjs from 'dayjs';
import {v4 as uuidv4} from 'uuid';

let loadingCategories = false;
let categories = [];
const HelperPlugin = {
  install(/* vue */) {
    Vue.mixin({
      computed: {
        $categoryTypes: function () {
          return [
            {text: i18n.tc('categories.personnel'), value: 'PERSONNEL'},
            {text: i18n.tc('categories.management'), value: 'MANAGEMENT'},
          ];
        },
        $tenant() {
          let savedTenant = tenantService.tenant;
          if (savedTenant != null) {
            return savedTenant;
          }

          if (savedTenant == null && this.$userInfo && this.$userInfo.tenants.length > 0) {
            return this.$userInfo.tenants[0]?.id;
          }
          return null;
        },
        $currentTenant() {
          return this.$userInfo.tenants?.find(t => t.id === this.$tenant);
        },

        $currentTenantPlan() {
          let status = this.$currentTenant?.status;
          if (!this.$isPaidTenant) {
            status = 'FREE';
          }
          return status;
        },
        $isPaidTenant() {
          return ['PRO', 'TOTAL'].includes(this.$currentTenant?.status);
        },
        $plans() {
          return [
            {
              name: i18n.t('tenants.statuses.FREE'),
              value: 'FREE',
              limits: {
                answerers: 10,
                suggestedTasks: 5,
              },
            },
            {
              name: i18n.t('tenants.statuses.PRO'),
              value: 'PRO',
              limits: {
                answerers: 250,
                suggestedTasks: Infinity,
              },
            },
            {
              name: i18n.t('tenants.statuses.TOTAL'),
              value: 'TOTAL',
              limits: {
                answerers: Infinity,
                suggestedTasks: Infinity,
              },
            },
          ];
        },
        $planLimit() {
          return this.$plans.find(p => p.value === this.$currentTenantPlan)?.limits;
        },
        $nextPlan() {
          return this.$plans[this.$plans.findIndex(p => p.value === this.$currentTenantPlan) + 1] || {};
        },
        $isTenantRoute() {
          if ('tenantId' in this.$route.params) {
            return true;
          }
          return false;
        },
        $userApi() {
          return userApi;
        },
        $adminApi() {
          return adminApi;
        },
        $systemApi() {
          return systemApi;
        },
        $tenantApi() {
          return tenantApi;
        },
        $icons() { // PORT-388 UI
          return false;
        },
        $baseUrl() {
          const hasCustomBaseUrl = process.env.VUE_APP_API_BASEURL.indexOf('undefined') === -1;
          if (hasCustomBaseUrl) {
            return process.env.VUE_APP_API_BASEURL;
          }
          return '';
        },
        $bottomNavigationStyle() {
          if (this.$vuetify.breakpoint.xsOnly) {
            return 'z-index: 5; bottom: 72px';
          }
          return '';
        },
        $questionCategories() {
          return {
            '-LwTcWMl9ADFEkzz1O3l': {category: 'efficiency', subcategory: 'ORGANISAATIO'},
            '-LwTdq4pBMZytFYBgW0C': {category: 'efficiency', subcategory: 'ORGANISAATIO'},
            '-LwTe4DF0y64qm8ZVTGA': {category: 'efficiency', subcategory: 'ORGANISAATIO'},
            '-LwTe6JYg_DyafV_zE10': {category: 'efficiency', subcategory: 'PROSESSIT'},
            '-LwTeI-h0V6YWK5SuPG1': {category: 'efficiency', subcategory: 'PROSESSIT'},
            '-LwTeSkiZ_PlB5LVo8x3': {category: 'efficiency', subcategory: 'PROSESSIT'},
            '-LwTe_ssfnWe-QAyfZai': {category: 'efficiency', subcategory: 'YHTEISTYÖ'},
            '-LwTeweWt0PCPxJIv4lF': {category: 'efficiency', subcategory: 'YHTEISTYÖ'},
            '-LwTezeIfXsXKxC7PMfr': {category: 'efficiency', subcategory: 'YHTEISTYÖ'},
            '-LwTfDS0aR1HRUOdrVAi': {category: 'capability', subcategory: 'TYÖKYKY'},
            '-LwTfiXzTnSoSQPBzs38': {category: 'capability', subcategory: 'TYÖKYKY'},
            '-LwTfybgmRGEsndcGaTH': {category: 'capability', subcategory: 'TYÖKYKY'},
            '-LwTg4iStJ6Dh1OpJ7Fh': {category: 'capability', subcategory: 'OSAAMINEN'},
            '-LwTgBSqxGbn5zjfieCl': {category: 'capability', subcategory: 'OSAAMINEN'},
            '-LwTgFkFOGPAjMxRpjub': {category: 'capability', subcategory: 'OSAAMINEN'},
            '-LwTgN020G5YjPg8cmkO': {category: 'capability', subcategory: 'MOTIVAATIO'},
            '-LwTgS4WlCEjalLN0kx7': {category: 'capability', subcategory: 'MOTIVAATIO'},
            '-LwTgXPjzip3S9Jxe1Hw': {category: 'capability', subcategory: 'MOTIVAATIO'},
          };
        },
        $taskPriorities() {
          return [
            {value: 'HIGH', name: this.$t('tasks.priorities.HIGH')},
            {value: 'MEDIUM', name: this.$t('tasks.priorities.MEDIUM')},
            {value: 'LOW', name: this.$t('tasks.priorities.LOW')},
          ];
        },
        /*$categories() {
          return {
            efficiency: {
              'ORGANISAATIO': ['RAKENNE', 'VALTA/VASTUU', 'YHTENÄISYYS'],
              'PROSESSIT': ['MÄÄRITYS JA KUVAUS', 'MITTARISTO', 'TOIMINTAOHJEET'],
              'YHTEISTYÖ': ['TIIMIYTYMISEN VAIHE', 'YHTEISET TAVOITTEET', 'VUOROVAIKUTUS TIIMIN SISÄLLÄ']
            },
            capability: {
              'TYÖKYKY': ['YLEINEN TERVEYDENTILA', 'SAIRAUSPOISSAOLOT', 'KOETTU STRESSI'],
              'OSAAMINEN': ['NYKYINEN OSAAMISTASO', 'OSAAMISTAVOITTEET', 'OSAAMISEN KEHITTÄMINEN'],
              'MOTIVAATIO': ['TYÖTYYTYVÄISYYS', 'MOTIVAATION MUOTO', 'OSAAMISEN KEHITTÄMISEN TUKI']
            },
            leadership: {
              'ASIA': ['NIMI1', 'NIMI2', 'NIMI3'],
              'YKSILÖ': ['NIMI4', 'NIMI5', 'NIMI6'],
              'TIIMI': ['NIMI7', 'NIMI8', 'NIMI9']
            },
            culture_leadership: {
              'KULTTUURI': ['DOKUMENTOITU STRATEGIA', 'HENKILÖSTÖKYSELYT', 'LAATUKÄSIKIRJA', 'ISO-AUDITOINNIT', 'LEAN-KOULUTUKSET/TUTKINNOT'],
              'JOHTAMINEN': ['JOHTAMISARVIOINTI', 'JOHTAMISEN/ESIMIESTYÖN KEHITTÄMINEN', 'KEHITYSKESKUSTELUKÄYTÄNTÖ', 'PALKITSEMISMALLIT']
            },
            economy_customers: {
              'TALOUS': ['TALOUS', 'TALOUDEN TAVOITTEET', 'MUUT KRIITTISET TALOUDEN MITTARIT'],
              'ASIAKKAAT': ['ASIAKASTYYTYVÄISYYDEN MITTARI', 'ASIAKASMÄÄRÄ/SEGMENTIT', 'ASIAKKUUDEN LAATUMITTARIT']
            },
          }
        }*/
        $theme() {
          return this.$vuetify.theme.themes.light
        },
      },
      methods: {
        $isValidEmail(mail) {
          if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
            return true;
          }
          return false;
        },
        $showSuccessNotification(message) {
          UiEventBus.$emit('showNotification', {
            color: 'success',
            message,
            showButton: false,
          });
        },
        $showWarningNotification(message) {
          UiEventBus.$emit('showNotification', {
            color: 'warning',
            message,
            showButton: false,
          });
        },
        $showErrorNotification(message) {
          const msg = message != null ? message : i18n.t('generic_error');
          UiEventBus.$emit('showNotification', {
            color: 'error',
            message: msg,
            showButton: false,
          });
        },
        $showPlanNotification(message) {
          let showButton = false;
          if (this.$hasMatchingTenantRoles(['tenant_admin'])) showButton = true;
          UiEventBus.$emit('showNotification', {
            color: 'warning',
            message,
            showButton: showButton,
            buttonText: i18n.t('tenants.upgrade_plan'),
            callback: () => {
              this.$router.push({name: 'tenant_settings'});
            },
          });
        },
        $numeral: numeral,

        $formatNumber1Dec(num) {
          return this.$numeral(parseFloat(num)).format('0.0');
        },

        $formatNumberInt(num) {
          return this.$numeral(parseFloat(num)).format('0,0');
        },
        $formatNumber(num, format = '0,0.0') {
          return this.$numeral(parseFloat(num)).format(format);
        },
        $formatNumberIntAppendix(num, appendix) {
          return this.$numeral(parseFloat(num)).format('0,0') + ' ' + appendix;
        },

        $formatNumber2DecAppendix(num, appendix) {
          return this.$numeral(parseFloat(num)).format('0,0.[00]') + ' ' + appendix;
        },
        /**
         *
         * @param {!error} err
         * @param {msg} [msg] message to show
         */
        $handleApiError(err, msg) {
          console.error(err);
          if (err.response != null && err.response.data && err.response.data.error_key != null) {
            this.$showErrorNotification(i18n.t(err.response.data.error_key));
          } else {
            this.$showErrorNotification(msg);
          }
        },
        $reloadApp() {
          location.reload();
        },
        $formatTimeStamp(date) {
          return dayjs(date).format('LLLL');
        },
        $formatDateNoTime(date) {
          return date ? dayjs(date).format('L') : '';
        },
        /*$formatDateTime(date) {
          return date ? dayjs(date).format('DD.MM.YYYY HH:mm:ss') : ''
        },*/
        $formatDateTime(date) {
          // International version
          return date ? dayjs(date).format('L LT') : '';
        },
        $formatYear(date) {
          return date ? dayjs(date).format('YYYY') : '';
        },
        $formatWeekDay(date) {
          return date ? dayjs(date).format('dd').capitalize() : '';
        },
        $formatTimeNoDate(date) {
          if (date) {
            return dayjs(date).format('LT');
          }
        },
        $formatMonthAndYear(date) {
          if (date) {
            return dayjs(date).format('MMM YYYY');
          }
        },
        $formatMonthAndYearLong(date) {
          if (date) {
            return dayjs(date).format('MMMM YYYY');
          }
        },
        $humanizeDuration(duration, showSeconds = false) {
          if (duration.asHours() > 23) {
            return Math.floor(duration.asHours()) + 'h ' + duration.minutes() + 'min';
          }
          return duration.hours() + 'h ' + duration.minutes() + 'min ' + (showSeconds ? duration.seconds() + 's' : '');
        },

        $formatDaysUntilDate(date) {
          if (date) {
            return dayjs(date).diff(dayjs(), 'day');
          }
        },
        $randomizeColorFromString(string, saturation = 75, lightness = 40) {
          let hash = 0;
          if (string?.length > 0) {
            for (let i = 0; i < string.length; i++) {
              hash = string.charCodeAt(i) + ((hash << 5) - hash);
              hash = hash & hash; // Convert to 32bit integer
            }
          }

          if (hash < 0) hash = hash * -1;

          let shortened = hash % 200;
          return `hsl(${shortened}, ${saturation}%, ${lightness}%)`;
        },
        $getImageUrl(imageKey) {
          return `${this.$baseUrl}/api/public/image/${imageKey}`;
        },
        $getGravatarUrl(email, size) {
          const picSize = size ? size : '68';
          const hash = md5(email.toLowerCase().trim());
          return `https://www.gravatar.com/avatar/${hash}?s=${picSize}&d=mm`; // eslint-disable-line no-undef
        },
        $workTaskStatusIcon(status) {
          switch (status) {
            case 'RECEIVED':
              return 'mdi-archive-outline';
            case 'WAITING':
              return 'mdi-timer-sand';
            case 'INPROGRESS':
              return 'mdi-progress-wrench';
            case 'DONE':
              return 'mdi-check';
            default:
              return '';
          }
        },
        $snakeCase(str) {
          return str?.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        },
        $fileNameValidator(filename) {
          return FileNameValidator(filename);
        },
        $confirm(type, title, message) {
          return this.$root.$confirm(title, message, {color: type});
        },
        $confirmDelete(title, message) {
          return this.$root.$confirm(title, message, {color: 'error', agree: this.$t('delete')});
        },
        $randomString() {
          return (Math.random() + 1).toString(36).substring(2);
        },
        async $loadUsers() {
          try {
            return await this.$userApi.getCloudUsers();
          } catch (error) {
            this.$store.dispatch('showNotification', {
              color: 'error',
              message: this.$t('errors.error_loading_users'),
              timeOut: 10000,
            });
            console.log(error);
          }
          return null;
        },
        $tidTextField(field) {
          return field?.replace(new RegExp('Tid$'), 'Text');
        },
        $uuid() {
          return uuidv4();
        },

        $getScoreColor(score, scale = [40, 60]) {
          if (score < 0) return 'grey lighten-3';
          if (score <= scale[0]) return 'weakness';
          if (score > scale[0] && score <= scale[1]) return 'opportunity';
          if (score > scale[0]) return 'strength';
        },
        $getScoreColorHex(score, scale = [40, 60]) {
          if (score <= scale[0]) return this.$theme.weakness;
          if (score > scale[0] && score <= scale[1]) return this.$theme.opportunity;
          if (score > scale[1]) return this.$theme.strength;
        },

        $textColorByType(type) {
          if (type === 'strength') return 'strength--text';
          if (type === 'weakness') return 'weakness--text';
          if (type === 'opportunity') return 'opportunity--text';
        },
        $textColorAgainstBGByType(type) {
          if (type === 'strength') return 'white--text';
          if (type === 'weakness') return 'white--text';
          if (type === 'opportunity') return 'black--text';
        },
        $colorByType(type) {
          if (type === 'strength') return 'strength';
          if (type === 'weakness') return 'weakness';
          if (type === 'opportunity') return 'opportunity';
        },
      },
    });
  },
};
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
export default HelperPlugin;
